import React, { useContext, useEffect, useRef, useState } from "react";
import AuthContext from "../../contexts/authContext";
import Loading from "../../components/shared/Loading";
import { apiURL, getData, patchData, postData } from "../../services/API";
import NoticeMsg from "../../components/shared/NoticeMsg";
import { CheckError } from "./checkError";
import { useForm } from "react-hook-form";
import { Toast } from "primereact/toast";

import form from "../../components/shared/Form/form.json";
import fa from "../core/lang/fa.json";
import { idGenerator, translateLabel } from "../../helper/helper";

// forms & api
import Input from "../../components/shared/Form/Input";
import config from "./config.json";
import { UserData } from "../../contexts/UserInfoContext";
import { useNavigate } from "react-router-dom";
import { getItemStorage } from "../../Localstorage/useLocalStorage";
import { Dropdown } from "primereact/dropdown";

const ProfileInfo = ({ profile }) => {
  // destructor
  const {
    api_url: { pc_complete_info, g_user_profile },
  } = config;

  const navigate = useNavigate();

  // useForm hook
  const { register, getValues, setValue } = useForm();

  const registerInputes = new Map(Object.entries(pc_complete_info.input));

  const toastLogin = useRef(null);

  const textInputes = [];

  // context
  const authContext = useContext(AuthContext);
  const { setUser } = useContext(UserData);

  const [name, setName] = useState("");
  const [lastName, setLastName] = useState("");
  const [validate, setValidate] = useState(false);
  const [loading, setLoading] = useState(false);
  const [errMsg, setErrMsg] = useState({});
  const [password, setPassword] = useState("");
  const [progress, setProgress] = useState("0%");
  const [message, setMessage] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [selectedGender, setSelectedGender] = useState({
    name: "مرد",
    code: "male",
  });
  const [genders, setGenders] = useState([
    { name: "مرد", code: "male" },
    { name: "زن", code: "female" },
    { name: "دیگر", code: "other" },
  ]);

  const ref = getItemStorage("ref");

  useEffect(() => {
    if (ref) {
      setValue("ref_code", ref);
    }
  }, []);

  registerInputes.forEach((item, value) => {
    textInputes.push(
      item.type === "text" && (
        <Input
          key={idGenerator()}
          element={"input"}
          type={item.type}
          label={item.label}
          placeHolder={item.label}
          register={{ ...register(value) }}
          error={errMsg[value]}
          wrapperClass="text-input-register"
        />
      )
    );
  });

  const submitHandler = (e) => {
    e.preventDefault();

    if (getValues("name") && getValues("family_name") && password) {
      setErrMsg({});
      setLoading(true);
      setValidate(false);

      !loading &&
        postData(
          pc_complete_info.url,
          {
            phone_number: authContext.userInfo.phone_number,
            ...getValues(),
            gender: selectedGender.code,
            password,
            vcode: authContext.userInfo.vcode,
            ord: "$2y$10$a0tQbs7S6OgfrgvKU9PmCuGKmj1/YlNSbrkrZxWhjoFD4M.1OJYlu",
          },
          false
        )
          .then((res) => {
            if (res.data.profile === "yes") {
              authContext.userCompleteProfile(res.data, { ...getValues() });

              // toast message
              toastLogin.current.show({
                severity: "success",
                summary: "ثبت نام با موفقیت انجام شد",
                detail: "در حال انتقال به پنل کاربری...",
                life: 3500,
              });

              // get user data
              getData(g_user_profile.url, {}, true)
                .then((res) => {
                  setLoading(false);
                  setUser(res.data);
                  if (res.data.user.name.includes("Admin")) {
                    navigate("/admin");
                  } else {
                    navigate("/user");
                  }
                })
                .catch((err) => {});
            } else {
              toastLogin.current.show({
                severity: "error",
                summary: "خطا هنگام تکمیل پروفایل",
                detail: "ارتباط با سرور با خطا مواجه شد لطفا دوباره تلاش کنید",
                life: 3500,
              });
            }
          })
          .catch((error) => {
            setLoading(false);
            setErrMsg(error.response.data);
          });
    } else {
      setValidate(true);
    }
  };

  const onChangeHandler = (passValue) => {
    setErrMsg({});

    const strengthCheck = {
      length: 0,
      hasLowerCase: false,
      hasUpperCase: false,
      hasDigits: false,
      hasSpecialChar: false,
    };

    strengthCheck.length = passValue.length >= 6 ? true : false;
    strengthCheck.hasLowerCase = /[a-z]+/.test(passValue);
    strengthCheck.hasUpperCase = /[A-Z]+/.test(passValue);
    strengthCheck.hasDigits = /[0-9]+/.test(passValue);
    strengthCheck.hasSpecialChar = /[^A-Za-z0-9]+/.test(passValue);

    const verifiedList = Object.values(strengthCheck).filter((value) => value);

    const strength =
      verifiedList.length === 5
        ? "رمز عبور شما قوی است"
        : verifiedList.length >= 2
        ? "رمز عبور شما متوسط است"
        : "رمز عبور شما ضعیف است";

    setPassword(passValue);
    setProgress(`${(verifiedList.length / 5) * 100}%`);
    setMessage(strength);
  };

  const getStrengthColor = (message) => {
    if (message === "رمز عبور شما قوی است") return "#3FBB60";
    if (message === "رمز عبور شما متوسط است") return "#FE804D";
    return "#FF0054";
  };

  return (
    <div>
      {/* toast message */}
      <Toast ref={toastLogin} />

      {validate && (
        <NoticeMsg msg={"تمامی فیلد ها الزامی میباشند."} notice={"error"} />
      )}
      <form
        className={`complete-register flex flex-col gap-4 mt-6 transition-all duration-300`}
        onSubmit={submitHandler}
      >
        {/* text inputes */}
        {textInputes}

        {/* radio inputes */}
        <div className="flex flex-col gap-2 animate-delay-4">
          <label>جنسیت</label>

          <Dropdown
            className="h-[50px] min-w-44 filter-dropdown bg-gray-100 !text-gray-800 border-none flex items-center justify-center rounded-xl"
            value={selectedGender}
            options={genders}
            optionLabel="name"
            // filter
            onChange={(e) => setSelectedGender(e.value)}
            emptyMessage="آیتمی وجود ندارد"
          />
        </div>

        {/* password input */}
        <div className="w-full flex flex-col gap-2">
          <label>رمز عبور</label>
          <div className="relative">
            {/* {passwordInput} */}
            <input
              type={showPassword ? "text" : "password"}
              placeholder={"رمز عبور خود را وارد کنید"}
              className={`${
                errMsg?.password
                  ? "ring-1 ring-red-600 bg-red-50 focus:ring-red-600"
                  : "ring-[#2f52ef] focus:ring-[#2f52ef] bg-gray-100"
              } w-full h-[50px] rounded-xl px-4 outline-none focus:ring-2 focus:!bg-white focus:shadow-lg focus:shadow-[#2f52ef5a] transition-all duration-200`}
              value={password}
              onChange={({ target }) => onChangeHandler(target.value)}
            />

            <div
              onClick={() => setShowPassword(!showPassword)}
              className="cursor-pointer outline-none border-none absolute top-2/4 -translate-y-2/4 left-3"
            >
              {showPassword ? (
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  strokeWidth="1.5"
                  stroke="currentColor"
                  className="w-6 h-6 stroke-[#2f52ef]"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M3.98 8.223A10.477 10.477 0 001.934 12C3.226 16.338 7.244 19.5 12 19.5c.993 0 1.953-.138 2.863-.395M6.228 6.228A10.45 10.45 0 0112 4.5c4.756 0 8.773 3.162 10.065 7.498a10.523 10.523 0 01-4.293 5.774M6.228 6.228L3 3m3.228 3.228l3.65 3.65m7.894 7.894L21 21m-3.228-3.228l-3.65-3.65m0 0a3 3 0 10-4.243-4.243m4.242 4.242L9.88 9.88"
                  />
                </svg>
              ) : (
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  strokeWidth="1.5"
                  stroke="currentColor"
                  className="w-6 h-6 stroke-[#2f52ef]"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M2.036 12.322a1.012 1.012 0 010-.639C3.423 7.51 7.36 4.5 12 4.5c4.638 0 8.573 3.007 9.963 7.178.07.207.07.431 0 .639C20.577 16.49 16.64 19.5 12 19.5c-4.638 0-8.573-3.007-9.963-7.178z"
                  />
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"
                  />
                </svg>
              )}
            </div>
          </div>
          {errMsg?.password && (
            <span className="text-red-600 text-sm">{errMsg.password[0]}</span>
          )}

          <span className="text-gray-600 text-xs">
            رمز عبور باید شامل حروف بزرگ و کوچک انگلیسی، اعداد و کاراکتر های
            خاص(#$%&...) باشد.
          </span>

          {password.length > 0 && (
            <div className="w-full flex flex-col gap-1 mt-1">
              {/* progress bar */}
              <div className="w-full bg-gray-50 h-2 rounded-full">
                <div
                  style={{
                    width: progress,
                    backgroundColor: getStrengthColor(message),
                  }}
                  className="h-full rounded-full transition-all"
                ></div>
              </div>
              <p
                style={{ color: getStrengthColor(message) }}
                className="text-sm"
              >
                {message}
              </p>
            </div>
          )}
        </div>

        {!loading ? (
          <button
            className="bg-blue animate-delay-8 text-white w-full h-11 rounded-xl shadow-lg shadow-blue-200 hover:bg-blue-700 transition-all duration-300"
            type="submit"
          >
            تکمیل اطلاعات پروفایل
          </button>
        ) : (
          <Loading />
        )}
      </form>
    </div>
  );
};

export default ProfileInfo;
